"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageCandidateMotion = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * The easing every image-candidate transition moves on: quick to start and
 * long to settle, so a tapped candidate answers at once. StyleX resolves
 * only variables across files, which is why this is `defineVars` rather
 * than an exported string; the full-screen view's grow animation runs
 * through the Web Animations API, which cannot read a variable, and names
 * the same curve itself.
 */
const imageCandidateMotion = exports.imageCandidateMotion = {
  ease: "var(--x1xli74d)",
  __themeName__: "xtpq53h"
};